import * as contextmenu from 'components/ContextMenu';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import preferences from 'Preferences';
import copyToClipboard from 'util/clipboard/copyToClipboard';

import {SidepanelRun} from './RunsSidepanelConstants';

export function getContextMenuOptions(run: SidepanelRun): Array<contextmenu.ContextMenuOption> {
  return [
    {
      name: 'Open',
      click: () => {
        FileBrowserActions.openFile(run.id);
      },
    },
    {
      name: 'Copy API ID',
      click: () => {
        copyToClipboard(run.warehouseId, {showToastOnSuccess: true});
      },
      hide: () => !preferences.get('ENABLE_COPY_API_ID'),
    },
  ];
}

export function open(e: Event, run: SidepanelRun): void {
  contextmenu.view.open(e, getContextMenuOptions(run));
}
